import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { LogoFacilityComponent } from 'src/app/shared/components';
import { DynamicDialogService } from 'src/app/shared/components/dynamic-dialog/services/dynamic-dialog.service';
import { MatStrokedButtonBorderDirective } from 'src/app/shared/directives/mat-stroked-button-border.directive';
import { SubscriptionAutopayComponent } from '../subscription-autopay/subscription-autopay.component';

@Component({
    selector: 'app-subscription',
    standalone: true,
    imports: [MatIconModule, MatButtonModule, LogoFacilityComponent, MatDialogModule, MatStrokedButtonBorderDirective],
    templateUrl: './subscription.component.html',
    styleUrl: './subscription.component.scss',
})
export class SubscriptionComponent {
    constructor(private dynamicDialogService: DynamicDialogService) {}

    continue(): void {
        this.dynamicDialogService.closeDialog();

        this.dynamicDialogService.showDialog<SubscriptionAutopayComponent>({
            dynamicComponent$: SubscriptionAutopayComponent,
            config: {
                width: '910px',
            },
        });
    }
}
